<template>
  <div>
    <div v-html="HeaderStatusHtmlText"></div>
  </div>
</template>

<script>
export default {
  props: {
    HeaderStatusHtmlText: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.extractAndExecuteScript()
  },
  methods: {
    // 提取并执行HTML字符串中的<script>内容（用Function替代eval）
    extractAndExecuteScript() {
      if (!this.HeaderStatusHtmlText) return

      // 1. 正则匹配<script>标签内的所有JS代码（兼容拆分写法</scr'+'ipt>）
      const scriptRegex = /<script[^>]*>([\s\S]*?)<\/scr'?\+?'?ipt>/i
      const match = this.HeaderStatusHtmlText.match(scriptRegex)
      
      if (match && match[1]) {
        let scriptCode = match[1]
        // 2. 清理多余的空格/换行/制表符，避免语法错误
        scriptCode = scriptCode.replace(/[\n\r\t]/g, '').trim()
        
        // 过滤空代码，避免无意义执行
        if (!scriptCode) return

        try {
          // 3. 用Function构造器执行脚本（比eval更安全）
          // Function构造器：参数为空，函数体为提取的脚本代码
          const executeScript = new Function(scriptCode)
          executeScript() // 执行脚本
        } catch (err) {
          console.error('执行脚本失败：', err)
        }
      }
    }
  }
}
</script>

<style>
</style>